module.exports = __webpack_public_path__ + "static/media/instagram-stories-basketball.2ab709a4.mp4";